import { render, staticRenderFns } from "./wap.vue?vue&type=template&id=f854b39a&scoped=true"
import script from "./wap.vue?vue&type=script&lang=js"
export * from "./wap.vue?vue&type=script&lang=js"
import style0 from "./wap.vue?vue&type=style&index=0&id=f854b39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f854b39a",
  null
  
)

export default component.exports